import { requestProjectApi } from 'serviceWorker/api/requestApi';
import { HttpError } from 'serviceWorker/helpers/httpError';
import { CONFLICT } from 'shared/contants';
import {
  IssueAccessChange,
  IssueAccessChangeKind,
  IssueAccessChangeResult,
} from 'shared/domain/issue/issueAccessChange';
import type { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import type { ApiRequest } from 'serviceWorker/api/requestApi';

function accessRequestOf(change: IssueAccessChange): ApiRequest {
  switch (change.kind) {
    case IssueAccessChangeKind.grant:
      return { method: 'POST', path: `issue/${change.issueId}/access`, body: change.body };
    case IssueAccessChangeKind.edit:
      return { method: 'PUT', path: `issue/${change.issueId}/access/${change.accessId}`, body: change.body };
    case IssueAccessChangeKind.revoke:
      return { method: 'DELETE', path: `issue/${change.issueId}/access/${change.accessId}` };
  }
}

/**
 * Saves the access change on the server. A grant answered with a conflict
 * means the user already has the access (another admin granted it, or the
 * page's list was stale): the wanted state holds, so it is not an error.
 */
export async function changeIssueAccess(change: IssueAccessChange): Promise<IssueAccessChangeResult> {
  try {
    const access = await requestProjectApi<UserAccess>(accessRequestOf(change));
    return { access };
  } catch (error) {
    if (change.kind === IssueAccessChangeKind.grant && error instanceof HttpError && error.status === CONFLICT) {
      return { alreadyGranted: true };
    }
    throw error;
  }
}
